// Can improve implementation to support different kinds of embedded contents, right now,
// it's only for embedded block and inline entries

export enum EmbeddedContentStatus {
  MISSING_INLINE_EMBEDDED_CONTENT = "MISSING_INLINE_EMBEDDED_CONTENT",
  MISSING_BLOCK_EMBEDDED_CONTENT = "MISSING_BLOCK_EMBEDDED_CONTENT",
}

export const hasMissingEmbeddedContent = (content: string): boolean =>
  content.includes(EmbeddedContentStatus.MISSING_INLINE_EMBEDDED_CONTENT) ||
  content.includes(EmbeddedContentStatus.MISSING_BLOCK_EMBEDDED_CONTENT);
